module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"candidate":"Кандидат"}}')
  delete Component.options._Ctor
}
